export default {
  message: state => state.message,
  loading: state => state.loading
}



// WEBPACK FOOTER //
// ./src/store/getters.js